import { chineseNumeralFormatter } from '@/src/libs/number-helper';
import { ListingDetail } from '@/swagger';

export const getOgDescription = (detailData: ListingDetail | ReplaceValueType<ListingDetail, Date, number>): string => {
  const { display_address, room, common_space, bath, price } = detailData;
  const subtitle = room || common_space || bath ? `${room || 0}房${common_space || 0}廳${bath || 0}衛 ` : '';
  return `${display_address} ${subtitle}${chineseNumeralFormatter(price || 0)}`;
};
